import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, Button, Table, Input } from 'reactstrap';
import AttendanceService from '../../axios_services/attendance.service';
import Loader from '../Loader/Loader';

const ModalPerfilesChecklist = ({ isOpen, onClose }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [profiles, setProfiles] = useState([]);
    const [trackedProfiles, setTrackedProfiles] = useState([]);

    useEffect(() => {
        if (isOpen) {
            loadData();
        }
    }, [isOpen]);

    const loadData = async () => {
        setIsLoading(true);
        try {
            const respP = await AttendanceService.getProfiles();
            setProfiles(respP.data || []);
            const respC = await AttendanceService.getConfigs();
            setTrackedProfiles(respC.data.tracked_profiles || []);
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleToggle = async (perfilId, current) => {
        setIsLoading(true);
        try {
            const nextValue = current ? 0 : 1;
            await AttendanceService.updateTrackedProfile({ perfil_id: perfilId, tracked: nextValue });
            // Refresh local state instead of full reload for speed
            setTrackedProfiles(prev => {
                const exists = prev.find(p => p.perfil_id === perfilId);
                if (exists) {
                    return prev.map(p => p.perfil_id === perfilId ? { ...p, tracked: nextValue } : p);
                }
                return [...prev, { perfil_id: perfilId, tracked: nextValue }];
            });
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} className="custom-modal" backdrop="static" size="md" centered>
            <ModalHeader className="modal-header">
                <div className="titulo">
                    <h1>GESTIÓN DE PERFILES</h1>
                    <Button className="close-btn" onClick={onClose}>X</Button>
                </div>
            </ModalHeader>
            <div className="modal-body-footer">
                <ModalBody className="modal-body">
                    <p className="text-muted small mb-3">
                        Marque los perfiles que podrán ser configurados en el módulo de asistencias.
                    </p>
                    {isLoading && <Loader />}
                    <div className="table-container table-responsive" style={{ maxHeight: '430px', overflowY: 'auto' }}>
                        <Table striped hover size="sm" className="mb-0">
                            <thead className="bg-light sticky-top">
                                <tr>
                                    <th>Perfil</th>
                                    <th className="text-center">Habilitar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {profiles.map(p => {
                                    const perm = trackedProfiles.find(ap => ap.perfil_id === p.perfil_id);
                                    // Handle both boolean and numeric (0/1) values safely
                                    const isTracked = perm ? (Number(perm.tracked) === 1) : false;
                                    return (
                                        <tr key={p.perfil_id}>
                                            <td style={{ padding: '10px' }}>{p.descripcion}</td>
                                            <td className="text-center">
                                                <Input 
                                                    type="checkbox" 
                                                    checked={isTracked} 
                                                    onChange={() => handleToggle(p.perfil_id, isTracked)} 
                                                    style={{ position: 'relative', margin: 0, width: '18px', height: '18px', cursor: 'pointer' }}
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </Table>
                    </div>
                </ModalBody>
            </div>
        </Modal>
    );
};

export default ModalPerfilesChecklist;
